import { useOnClickInside } from 'hooks/useOnClickInside'
import { dispatch } from 'store'
import { TIMELINE_PLUS_BUTTON_CLASS_NAME, TRACK_ITEM_CLASS_NAME } from 'consts'
import { TIMELINE_CONTENT_WRAPPER_ID } from './consts'
import { editorThunks } from 'store/features/editor/thunks'

const handleTimelineClick = () => {
  // Clear all selected timeline items and close aside overlay
  dispatch(editorThunks.deselectAllTimelineItems())
}

export const useDeselectTimelineItems = () => {
  useOnClickInside(TIMELINE_CONTENT_WRAPPER_ID, handleTimelineClick, [
    TRACK_ITEM_CLASS_NAME,
    TIMELINE_PLUS_BUTTON_CLASS_NAME
  ])
}
